import React, { useState } from 'react';
import './Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        
        {/* 🏎️ UNIFIED SLANT AXIS LOGO CONTAINER */}
        <a href="/" style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '12px', /* FIXED: Creates a clean, calculated space before the N */
          textDecoration: 'none', 
          flexShrink: 0,
          transform: 'skewX(-23deg)', /* Slants the bars AND the text at the exact same angle */
          transformOrigin: 'left center',
          willChange: 'transform'
        }}>
          
          {/* ⚡ THE PERFORMANCE BARS - CODED TO TRACK THE FONT HEIGHT PERFECTLY */}
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center', height: '24px' }}>
            {/* Bar 1: Light Burgundy Red */}
            <div style={{ width: '8px', height: '24px', backgroundColor: '#b91c1c', flexShrink: 0 }} />
            {/* Bar 2: Deep Crimson Industrial Red */}
            <div style={{ width: '8px', height: '24px', backgroundColor: '#991b1b', flexShrink: 0 }} />
            {/* Bar 3: Dark Obsidian Blood Red */}
            <div style={{ width: '8px', height: '24px', backgroundColor: '#7f1d1d', flexShrink: 0 }} />
          </div>

          {/* 🏢 THE TYPOGRAPHY TEXT NODE */}
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '24px' }}>
            <h1 style={{ 
              margin: 0, 
              fontSize: '24px', /* Exact match to the 24px bar height parameter */
              fontWeight: '900', 
              letterSpacing: '0.01em', 
              color: '#ffffff', 
              lineHeight: '1.0', /* Strips out legacy browser padding leaks */
              fontFamily: 'Inter, sans-serif',
              textTransform: 'uppercase',
              display: 'block'
            }}>
              NAK ENGINEERING LTD
            </h1>
          </div>
        </a>
        
        {/* 📁 FLUID RESPONSIVE TEXT LINK NAVIGATION PORTAL */}
        <nav className={`nav nav-links ${menuOpen ? 'open' : ''}`} style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
          <a href="/" onClick={() => setMenuOpen(false)}>Home</a>
          <a href="#tracks" onClick={() => setMenuOpen(false)}>Strategic Tracks</a>
          <a href="/#about" onClick={() => setMenuOpen(false)}>About</a>
          <a href="/case-studies" onClick={() => setMenuOpen(false)}>Case Studies</a>
        </nav>

        {/* 📱 MOBILE RESPONSIVE HAMBURGER NAVIGATION TRIGGER */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

      </div>
    </header>
  );
}

export default Header;
